import React from 'react';
import { Row, Form, Modal, DatePicker } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { useTranslation } from 'react-i18next';
import { DateFormat } from 'helpers/constants';
import {
  closeHeatmap,
  setHeatmapDateRange,
} from '../../../store/requests/zone';

const { RangePicker } = DatePicker;
const OrderHeatmapLayer = (props) => {
  const { setHeatmapModalOpen, setHeatmapChecked, heatmapForm } = props;
  const { t } = useTranslation();

  const onFinish = (values) => {
    const startDate = values.date[0].format(DateFormat.YearDateFormat);
    const finishDate = values.date[1].format(DateFormat.YearDateFormat);

    setHeatmapDateRange({ startDate, finishDate });
    setHeatmapModalOpen(false);
  };

  const onCloseHandlerHeatmap = () => {
    closeHeatmap();
    setHeatmapChecked(false);
    setHeatmapModalOpen(false);
  };

  return (
    <>
      <Modal
        centered
        closable
        open={true}
        maskClosable={false}
        onOk={() => heatmapForm.submit()}
        onCancel={onCloseHandlerHeatmap}
        title={t('dateRangeForHeatmap')}
        okText={t('show')}
        cancelText={t('cancel')}
      >
        <Row gutter={20}>
          <Form
            style={{ width: '100%' }}
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 24 }}
            name="basic"
            onFinish={onFinish}
            form={heatmapForm}
          >
            <FormItem
              rules={[
                {
                  required: true,
                  message: t('alert.fillField'),
                },
              ]}
              name="date"
            >
              <RangePicker
                placeholder={[
                  t('placeholder.startDate'),
                  t('placeholder.endDate'),
                ]}
                style={{ width: '100%' }}
                format={DateFormat.DayDateFormat}
              />
            </FormItem>
          </Form>
        </Row>
      </Modal>
    </>
  );
};

export default OrderHeatmapLayer;
